if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);
      this.tabButtons = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));

      var originalSetActiveTab = this.tabs.setActiveTab.bind(this.tabs);
      this.tabs.setActiveTab = (tabIndex) => {
        originalSetActiveTab(tabIndex);
        this.syncA11y(tabIndex);
      };

      this.tabButtons.forEach((button, index) => {
        button.addEventListener("keydown", (event) => this.onKeydown(event, index));
      });

      this.syncA11y(this.tabs.currentActiveIndex > -1 ? this.tabs.currentActiveIndex : 0);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          if (!this.contains(event.target)) return;
          var tabHeader = event.target;
          var index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    syncA11y(tabIndex) {
      this.tabButtons.forEach((button, index) => {
        var selected = index === tabIndex;
        button.setAttribute("aria-selected", selected ? "true" : "false");
        button.setAttribute("tabindex", selected ? "0" : "-1");
        button.classList.toggle("active", selected);
      });

      this.panels.forEach((panel, index) => {
        var selected = index === tabIndex;
        panel.classList.toggle("active", selected);
        if (selected) {
          panel.removeAttribute("hidden");
          panel.style.opacity = "1";
        } else {
          panel.setAttribute("hidden", "");
          panel.style.opacity = "";
        }
      });
    }

    onKeydown(event, index) {
      var key = event.key;
      var nextIndex = index;

      if (key === "ArrowRight" || key === "ArrowDown") {
        nextIndex = (index + 1) % this.tabButtons.length;
      } else if (key === "ArrowLeft" || key === "ArrowUp") {
        nextIndex = (index - 1 + this.tabButtons.length) % this.tabButtons.length;
      } else if (key === "Home") {
        nextIndex = 0;
      } else if (key === "End") {
        nextIndex = this.tabButtons.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.tabs.setActiveTab(nextIndex);
      this.tabButtons[nextIndex].focus();
    }
  }

  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
